export const TRUST_SCORE_RANGE_CONFIG = {
    step: 5,
    range: {
        min: 0,
        max: 100
    }
};